/***************************************************************************************
 * @module       Common Utils 
 * @name         techus-Common Utils
 * @description  Get the User Authentication Common Utils 
 * @version      1.0.0
 * @copyright    © 2024 Tech.us
 * @license      Licensed under the MIT License
 * @createdon    May 2024
 * @modifiedon   May 2024
 * @since        1.0
 ***************************************************************************************/
import { parsePhoneNumber } from 'libphonenumber-js';
import { pdfjs } from 'react-pdf';

pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.min.js`;

export function formatDateFromISOString(dateString) { 
  // Create a new Date object from the ISO string
  let date = new Date(dateString);

  // Extract the month, day, and year from the Date object
  let month = date.getMonth() + 1; // Months are zero indexed, so we add 1
  let day = date.getDate();
  let year = date.getFullYear();

  // Format the date in MM/DD/YYYY format
  let formattedDate = `${month.toString().padStart(2, '0')}/${day.toString().padStart(2, '0')}/${year}`;

  return formattedDate;  // Outputs: "07/11/2024"
}

export function formatDateFromISOStrings(dateString) { 
  // Create a new Date object from the ISO string
  let date = new Date(dateString);

  // Extract the month, day, and year from the Date object
  let month = date.getMonth() + 1; // Months are zero indexed, so we add 1
  let day = date.getDate();
  let year = date.getFullYear();

  // Format the date in MM/DD/YYYY format
  let formattedDate = `${month.toString().padStart(2, '0')}-${day.toString().padStart(2, '0')}-${year}`;

  return formattedDate;  // Outputs: "07/11/2024"
}

export function formatDateString(dateString) {
  const date = new Date(dateString);

  const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
  const month = monthNames[date.getMonth()];
  const day = String(date.getDate()).padStart(2, '0');
  const year = date.getFullYear();

  let hours = date.getHours();
  const minutes = String(date.getMinutes()).padStart(2, '0');
  const ampm = hours >= 12 ? 'PM' : 'AM';
  hours = hours % 12;
  hours = hours ? hours : 12; // the hour '0' should be '12'

  return `${month} ${day}, ${year} ${hours}:${minutes} ${ampm}`;
}

export function formatDateStringUS(dateString) {
  const date = new Date(dateString);

  // Convert to Eastern Time (New York)
  const options = {
    timeZone: "America/New_York", // EST/EDT timezone
    year: "numeric",
    month: "short",
    day: "2-digit",
    hour: "numeric",
    minute: "2-digit",
    hour12: true,
  };

  return new Intl.DateTimeFormat("en-US", options).format(date);
}

// capitailse first letter

export const capitalizeFirstLetter = (string) => {
  if (!string) return '';
  return string.charAt(0).toUpperCase() + string.slice(1);
};

export const allowOnlyNumbersWithTwoDecimals = (event) => {
  const charCode = event.which ? event.which : event.keyCode;
  const charStr = String.fromCharCode(charCode);
  const inputValue = event.target.value;

  // Allow numbers and a single decimal point
  if (!/[0-9]/.test(charStr) && charStr !== '.') {
    event.preventDefault();
  }

  // Prevent multiple decimal points
  if (charStr === '.' && inputValue.includes('.')) {
    event.preventDefault();
  }

  // Ensure only two decimal places
  const decimalIndex = inputValue.indexOf('.');
  if (decimalIndex !== -1 && inputValue.length - decimalIndex > 4) {
    event.preventDefault();
  }
};

export const allowOnlyNumbersWithTwoDecimalsOrMinutes = (event) => {
  const charCode = event.which ? event.which : event.keyCode;
  const charStr = String.fromCharCode(charCode);
  const inputValue = event.target.value;

  // Allow numbers, a single decimal point, and a minus sign only at the beginning
  if (!/[0-9]/.test(charStr) && charStr !== '.' && charStr !== '-') {
    event.preventDefault();
    return;
  }

  // Prevent minus sign if it's not at the beginning
  if (charStr === '-' && inputValue.length > 0) {
    event.preventDefault();
    return;
  }

  // Prevent multiple decimal points
  if (charStr === '.' && inputValue.includes('.')) {
    event.preventDefault();
    return;
  }

  // Check if the current input is a minute value (0-59) or -59 to -0
  const numValue = parseFloat(inputValue + charStr);
  if (!isNaN(numValue) && Math.abs(numValue) <= 59 && !inputValue.includes('.')) {
    return; // Allow minutes up to 59 or down to -59 without decimals
  }

  // Ensure only two decimal places
  const decimalIndex = inputValue.indexOf('.');
  if (decimalIndex !== -1 && inputValue.length - decimalIndex > 2) {
    event.preventDefault();
  }
};

export const findDuplicates=(data, targetId) =>{
  const duplicates = []; // To store duplicate objects

  // Iterate through each page in data
  Object.values(data).forEach(pageArray => {
      // Check if pageArray is an array
      if (Array.isArray(pageArray)) {
          pageArray.forEach(item => {
              const id = item.structure_details.extract_structure_id;
              // If the id matches the targetId, add to duplicates
              if (id === targetId) {
                  duplicates.push(item);
              }
          });
      }
  });

  // Return duplicates only if there are multiple occurrences
  return duplicates.length > 1 ? duplicates : [];
}


export const getDescription=(structure)=> {

  const { is_dot, width_ft, height_ft, length_ft, wall_type, structure_type, category_id ,description} = structure;
   
  function formatDescription(input) {
  return input.replace(/(\d+"\s*)([A-Z\s]+)/, (_, prefix, text) => {
    return prefix + text
      .trim()
      .toLowerCase()
      .split(/\s+/)
      .map(word => word.charAt(0).toUpperCase() + word.slice(1))
      .join('');
  });
}

  if(structure_type=='HW'){
   return formatDescription(description) || '';
  }
  // Check if category is 1
  if (category_id !== 1) {
    return '-'; // Return empty if category_id is not 1
  }

  
  // Determine wall type description
  let wallTypeDesc = is_dot!==1? wall_type === 1 ? 'Solid' : 'Waffle':'Custom'

 // Check if structure is a manhole type (MH or SS/SSMH)
 if (structure_type === 'MH' || structure_type === 'SS' || structure_type === 'SSMH') {
   // Manholes: convert width from feet to inches (width_ft * 12)
   return `${width_ft * 12}" ${wallTypeDesc} Manhole`;
 }

 if (length_ft !== null) {
   // Catch Basin (CB) with Length
   return `${width_ft}x${length_ft} ${wallTypeDesc} Box`;
 } else {
   // Default: convert to inches for manhole description
   return `${width_ft * 12}" ${wallTypeDesc} Manhole`;
 }

  return '-'; // Default case
}

export const allowPipeDiameterInput = (event) => {
  const charCode = event.which ? event.which : event.keyCode;
  const charStr = String.fromCharCode(charCode);
  const inputValue = event.target.value;

  // Allow numbers and a single decimal point
  if (!/[0-9]/.test(charStr) && charStr !== '.') {
    event.preventDefault();
  }

  // Prevent multiple decimal points
  if (charStr === '.' && inputValue.includes('.')) {
    event.preventDefault();
  }

  // Ensure only two decimal places
  const decimalIndex = inputValue.indexOf('.');
  if (decimalIndex !== -1 && inputValue.length - decimalIndex > 3) { // 2 decimal places + 1 for '.'
    event.preventDefault();
  }

  // Ensure the number stays between 0 and 99
  const numberValue = parseFloat(inputValue + charStr); // Potential new value after typing
  if (numberValue > 99 || numberValue < 0) {
    event.preventDefault();
  }
};


export const allowPipeAngleInput = (event) => {
  const charCode = event.which ? event.which : event.keyCode;
  const charStr = String.fromCharCode(charCode);
  const inputValue = event.target.value;

  // Allow only numbers (no decimal points or non-numeric characters)
  if (!/[0-9]/.test(charStr)) {
    event.preventDefault();
  }

  // Ensure the number stays between 0 and 359 (whole numbers only)
  const numberValue = parseInt(inputValue + charStr, 10); // Potential new value after typing
  if (numberValue > 359 || numberValue < 0) {
    event.preventDefault();
  }
};

export const formatPhoneNumber = (num) => {
  if(num && num.length>5){
  const phoneNumber = parsePhoneNumber(num, 'US');
  return phoneNumber ? phoneNumber.formatNational() : num;
  }else{
    return num
  }
};

export const extractPDFOutline = async (file) => {
  try {
      const arrayBuffer = await file.arrayBuffer();
      const pdf = await pdfjs.getDocument({ data: arrayBuffer }).promise;
      const outline = await pdf.getOutline();
      
      if (!outline) {
          return [];
      }

      const titles = outline[0].items.map(item => item.title);

      return titles;
  } catch (error) {
      console.error("Error extracting PDF outline:", error);
      return [];
  }
};


export const formatDateWithTime=(dateString)=> {
  const date = new Date(dateString);
  const options = {
    month: '2-digit',
    day: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    hour12: true,
  };

  return date.toLocaleString('en-US', options);
  // Output: "07/22/2024, 10:15 AM"
}

export const removeStructureSuffix=(id)=> {
  // Check if string ends with -i or -ii
  if (id.endsWith('-i') || id.endsWith('-ii')) {
      // Remove the last -i or -ii by getting substring up to last hyphen
      return id.substring(0, id.lastIndexOf('-'));
  }
  return id;
}

export const calculateDimensionIntoFt = (dimensionFt, dimensionIn) => {
  const ft = parseInt(dimensionFt);
  const inches = parseInt(dimensionIn);

  if (!isNaN(ft) && !isNaN(inches) && dimensionFt !== 0 || dimensionIn !== 0 && !isNaN(ft)) {
    // return (ft + inches / 12).toFixed(2) + ' Ft';
    const totalFt = (ft + inches / 12).toFixed(2);
    const [beforeDot, afterDot] = totalFt.split('.');
    
    return {
      ft: beforeDot , // part before the decimal
      in: afterDot // part after the decimal, converted to inches
    };
  }
  return {
    ft:'', // part before the decimal
    in:'' // part after the decimal, converted to inches
  };
};

export const calculateDimensionsFtToIn = (dimensionFt) => {
  dimensionFt = dimensionFt
  
  const totalInches = dimensionFt * 12; // Convert feet to inches
  const ft = Math.floor(dimensionFt); // Extract the feet part
  const inches = Math.round(totalInches % 12); // Extract the remaining inches part

  return {ft:ft,  in:inches};
};



export const calculateDimensionIntoFts = (dimensionFt, dimensionIn) => {
  const ft = parseInt(dimensionFt);
  const inches = parseInt(dimensionIn);

  if (!isNaN(ft) && !isNaN(inches) && dimensionFt !== 0 || dimensionIn !== 0 && !isNaN(ft)) {
    return (ft + inches / 12).toFixed(2);


  }
  return '';
};

// A structure is "locked" once it's left the Proposed workflow stage, or its
// drawing has been marked Approved — matches the backend's isEligibleForRecalc
// policy (mldetect.model.js, project.model.js, angleprediction.model.js): only
// status===1 && drawing_status!==3 structures get auto-recalculated silently.
export const isStructureLocked = (row) => {
  return row?.status !== 1 || row?.drawing_status === 3;
};

// Mirrors the backend's isUnnamedStructureId (structureNaming.utils.js): a
// structure with no real name should never be approvable.
export const isUnnamedStructureId = (structureId) => {
  const trimmed = String(structureId ?? '').trim();
  return trimmed === '' || /^NONAME/i.test(trimmed);
};

export const STRUCTURE_STATUS_LABELS = {
  1: 'Proposed',
  2: 'an RFI',
  3: 'Revised',
  4: 'Approved'
};

// Did a cell's value actually move? Inputs hand back strings even where the
// stored value is numeric, and an emptied field arrives as '' against a stored
// null, so compare on a normalised form rather than with ===.
// Used to avoid saving on a blur the user never typed into: a no-op save still
// marks the row dirty (dropping it off the quote screen) and, on a locked row,
// prompts about an edit that never happened.
export const isSameFieldValue = (a, b) => {
  const normalise = value =>
    value === null || value === undefined ? '' : String(value).trim();

  return normalise(a) === normalise(b);
};